import { createMultiStyleConfigHelpers as e } from "@chakra-ui/react";
const { defineMultiStyleConfig: t, definePartsStyle: n } = e([
  "container",
  "content",
  "graphic"
]), o = n({
  container: {
    backgroundColor: "white",
    flexDirection: "row",
    gap: "40px"
  },
  content: {
    p: { base: "16px", md: "40px" },
    flex: 1
  },
  graphic: {}
}), a = t({
  baseStyle: o
});
export {
  a as default,
  a as pageHeaderTheme
};
